// extracted by mini-css-extract-plugin
export default {"technology_block":"ResumeTechnology_technology_block__lgYxX","technology_item":"ResumeTechnology_technology_item__q2NVg"};